import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NotificacionesGlobalesService } from './core/services/notificaiones-globales.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  protected readonly title = signal('NovaMed-app');

  private notificaciones = inject(NotificacionesGlobalesService);

  ngOnInit(): void {
    this.notificaciones.iniciar();
  }
}
